import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-color-surface relative flex flex-col p-10',
    resendText: 'mt-6',
    inputText: '',
    helperText: 'text-tertiary heading-xs mx-auto mt-2 min-h-4.25 opacity-0',
    loadingContainer:
      'bg-surface absolute top-0 left-0 flex size-full items-center justify-center',
    loading: 'loading bg-surface h-5 w-16 transform transition-opacity'
  },
  variants: {
    status: {
      completed: {
        helperText: 'text-success opacity-100',
        inputText: 'text-success'
      },
      error: {
        helperText: 'text-error opacity-100',
        inputText: 'text-error'
      },
      loading: {},
      default: {}
    }
  },
  defaultVariants: {}
});
